import type { PartnerEnum } from '../groveSchedulerClient'
import type { PartnerSchemaInternal } from './types'

/**
 * Kolla partner configuration schema.
 *
 * Kolla brokers several dental PMS connectors. Onboarding selects a PMS
 * connector and (optionally) a provider for comm-log writeback; both lists
 * come from Partner Ops lookups. `consumer_id` (the practice identifier) is
 * entered by the onboarder and is declared first so it is filled before the
 * provider lookup — which depends on it — can run.
 */
export const kollaSchema: PartnerSchemaInternal = {
  partner: 'kolla' as PartnerEnum,
  displayName: 'Kolla',
  fields: [
    {
      key: 'consumer_id',
      label: 'Consumer ID',
      type: 'text',
      required: true,
      helperText: 'Kolla consumer ID identifying the dental practice.',
    },
    {
      key: 'connector_id',
      label: 'PMS Connector',
      type: 'remoteSelect',
      required: true,
      source: 'kolla.connectors',
      helperText: 'Practice management system to integrate with.',
    },
    {
      key: 'provider_id',
      label: 'Provider',
      type: 'remoteSelect',
      // Optional per the grove-scheduler PartnerConfigKolla contract, which
      // requires only consumer_id + connector_id. A provider is needed only
      // for comm-log writeback; when blank, writeback simply skips.
      // Open Dental specifically does NOT require a provider.
      required: false,
      source: 'kolla.providers',
      dependsOn: ['connector_id', 'consumer_id'],
      helperText:
        'Optional — required for comm-log writeback for all Kolla sources except Open Dental. Loads once a PMS connector and consumer ID are set.',
    },
  ],
}
